



















import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Modal from "@/mixins/Modal";
import CustomScroll from "@/components/CustomScroll";

@Component({ name: "BaseConfirm", components: { CustomScroll } })
export default class BaseConfirm extends mixins(Modal) {
  @Prop({ type: String })
  public readonly title!: string;

  @Prop({ type: Boolean, default: true })
  public readonly scrollable!: boolean;

  @Prop({ type: String })
  public classWrapper!: string;
}
